import { IOfferForClient1 } from '../../../../../repositories/chats/entities/for_client/OfferForClient1';

export const getOfferShareUrl = (offer: IOfferForClient1, isChatbotChat: boolean): string => {
  const { url } = offer;
  const param = `source=${isChatbotChat ? 'chat_bot' : 'chats'}`;

  return url.includes('?') ? `${url}&${param}` : `${url}?${param}`;
};
